import {dispatch} from 'od-modules/secure_store/store';
import {SET_TRAVELLER_ID} from 'od-modules/secure_store/actions';
import {isMembershipStatusActivated} from 'od-modules/utils/membership_utils';
const {hasRememberMeCookie} = require('od-modules/utils/sso.utils');
import {MEMBERSHIP_ACCOUNT_TYPE} from 'od-modules/utils/membership_constants';
const baggageOptionsCollection = require('../../modules/collections/baggages_row_options').getInstance();
const baggageCollectionBuilder = require('../../modules/builders/baggages').getInstance();

const priceFreezeDataNames = {
    'mail': 'email',
    'validationMail': 'email_confirm',
    'name': 'name',
    'phoneNumber1': 'phone',
    'firstLastName': 'surname',
};

export default (function() {
    'use strict';
    var trackingUtils = require('../utils/tracking.utils');
    var emailSuggestion = require('../utils/email_suggestion');
    var dropDownSelect = require('../utils/dropdown_select');
    var googlePlacesHelper = require('../utils/google_places_autocomplete');
    const collapsibleBox = require('../ui/collapsible_box');
    const optionNotSelected = 'option:not(.hidden)';
    const isUserLogged = hasRememberMeCookie();

    return Odigeo.View.extend({
        events: {
            'keyup @googlePlacesAutocompleteInput': 'updateAutocompleteGooglePlacesInput',
            'tap .get_place_id': 'getPlaceId',
            'tap .passenger_container': 'closeGooglePlaceAutocomplete',
            'tap .store_passenger_data': 'trackingStoreDetails',
            'tap @forceLoginButton': 'openLoginPopup',
            'tap @closeForceLogin': 'closeForceLoginPopup',
            'tap @removePax': 'onChangePaxAction',
        },
        isDomBinded: false,
        showAutocomplete: false,
        saveName: true,
        storeData: require('../utils/storeData.utils'),
        trackingUtils: require('../utils/tracking.utils'),
        fieldUtils: require('../utils/field.utils'),
        googlePlacesHelper: googlePlacesHelper,
        init: function() {
            // init google places auto-autocomplete module
            if (this.widget.options.getAutocompleteWithoutLocation > 1) {
                this.googlePlacesHelper.init('.input_autocomplete_address');
            }

            this.model.set('isTrackingSent', false);
            this.cacheDomSelectors();
            this.listenTo(this.model, 'change:validationMail', Odigeo._.bind(this.onValidationEmailModelChange, this));
            if (Odigeo.AB.isResidentDiscount) {
                this.listenTo(this.model, 'change:residentDiscountApplied', this.residentDiscountAppliedChanged.bind(this));
                this.residentDiscountAppliedChanged();
            }
            this.widget.options.validateOnlyRequired = JSON.parse(this.widget.options.validateOnlyRequired || 'false') ? '[required]' : '*';
            this.model.passengerType = this.widget.options.travellerType;
            this.widget.options.travellerType = this.widget.passengerTypes[this.$cachedSelectors.passengerTypeSelector.val() || 'ADULT'];
            this.widget.model.set({selectedBaggageQuantity: this.widget.getBaggageSelectedPieces()});

            this.widget.model.getInitialPassengers();

            if (JSON.parse(this.widget.options.hasExpandables || 'false')) {
                Odigeo.UIElements.enhanceExpandable(this.$el.find('.passenger_form_content'), {enabled: true});
            }

            Odigeo._.each(
                this.$el.find('.calendar_input'),
                function(el) {
                    if ($(el).data('name') === 'dateOfBirth') {
                        const travellerType = this.widget.options.travellerType;
                        const adultType = this.widget.passengerTypes.ADULT;
                        const shouldSetDefaultAverageDate = travellerType === adultType;
                        Odigeo.UIElements.enhanceInputDate(
                            el,
                            this.model.getEarliestPossibleBirthDate(),
                            this.model.getLatestPossibleBirthDate(),
                            shouldSetDefaultAverageDate
                        );
                    } else {
                        Odigeo.UIElements.enhanceInputDate(el);
                    }
                },
                this
            );

            this.bindToDom();

            this.widget.options.storageEnabled = Odigeo._.isUndefined(this.widget.options.storePassengers)
                ? this.$cachedSelectors.storePassengerCheckbox.is(':checked') || false
                : this.widget.options.storePassengers || false;

            this.widget.model.resetCacheBaggages();

            this.refreshPassengerSelector();

            this.firstLastNameLabelSwitch();

            this.identificationTypeValidations();

            // Update the validation method to be used for the buyer's ID card, according to the
            // one selected by default when this view is loaded.
            this.buyerValidation();

            this.$cachedSelectors.identificationType.bind(
                Odigeo.Events.change,
                Odigeo._.bind(function() {
                    this.identificationTypeValidations();
                }, this)
            );

            this.$cachedSelectors.buyerIdentificationType.bind(
                'change',
                Odigeo._.bind(function() {
                    this.buyerValidation();
                }, this)
            );

            this.$cachedSelectors.buyerCountry.bind(
                Odigeo.Events.change,
                Odigeo._.bind(function(data) {
                    this.showStateName(data.currentTarget.value);
                }, this)
            );

            if (!this.widget.options.isBuyer && this.$el.find('.input_wrapper_birth select').length) {
                Odigeo.UIElements.enhanceDateWithSelects.setRange(
                    this.$el.find('[data-name="dateOfBirth"]'),
                    this.model.getLatestPossibleBirthDate(),
                    this.model.getEarliestPossibleBirthDate()
                );
            }
            if (!isUserLogged) {
                trackingUtils.trackEvent('securely_store_details', 'securely-store-details_onload');
            }
            Odigeo._.forEach(
                this.$cachedSelectors.dropdownSelect,
                (element) => {
                    const name = $(element)
                        .find('.dropdown_select_selected')
                        .data('name');
                    dropDownSelect.initDropdown($(element), this.$cachedSelectors.dropdownOption, `buyer.${name}`, 'passengersData');
                },
                this
            );
        },
        selectors: {
            residentDiscountAlert: '.resident_discount_alert',
            passengerHeader: '.passenger_title',
            passengerOpenCard: '.passenger_open_card',
            passengerForms: '.passenger_forms',
            acronymCircle: '.acronym_circle',
            acronymText: '.acronym_text',
            changePax: '.change_pax',
            membershipTitle: '.membership_title',
            loggedInUser: '.logged_in_user',
            paxNameTitle: '.pax_name_title',
            paxType: '.pax_type',
            passengerContainer: '.passenger_container',
            identificationType: '[data-name="identificationType"]',
            buyerIdentificationType: '[data-name="buyerIdentificationType"]',
            identification: '[data-name="identification"]',
            passangermanagerSecondLastNameWrapper: '.second_last_name_container',
            passangermanagerSecondLastName: '[data-name="secondLastName"]',
            name: '[data-name="name"]',
            firstLastName: '[data-name="firstLastName"]',
            fullName: '[data-name="name"], [data-name="firstLastName"]',
            titleName: '.passenger_title_text',
            storedPassengers: '.stored_passengers select',
            storedPassengersWrapper: '.stored_passengers',
            storePassengerCheckbox: '.store_passenger',
            passengerTypeSelector: '[data-name="travellerType"]',
            stateName: '[data-name="stateName"]',
            formContent: '.form_content',
            middleName: '[data-name="middleName"]',
            passengerInputsOptional: '[data-requiredoptional="optional"]',
            addDocumentBtn: '.document_add_btn',
            documentsContainer: '.document_container',
            documents: '.document_section',
            passengerFields: '.validation_field',
            allFocused: 'input:not([type="hidden"]), select',
            allCalendars: '.calendar_input',
            selectsPlaceholder: '.select_input:has(option[placeholder])',
            selectField: '.select_input',
            baggage: '.od-passenger-bag-row',
            buyerEmail: 'input[data-name="mail"]',
            suggestionMail: '.mail_suggestion',
            suggestionValidationMail: '.validation_mail_suggestion',
            buyerEmailSuggestion: '.buyer_mail_suggestion',
            customersPaxManager: '.customers_pax_manager',
            customerSelector: '.customer_selector',
            contactDetailsSelector: '.contact_details_selector',
            editBuyerInfoButton: '.edit_buyer_info_button',
            buyerEditableEmail: '.buyer_editable_email',
            buyerNonEditableEmail: '.buyer_noneditable_email',
            passengerEmail: '.buyer_email',
            buyerConfirmEmailText: '.buyer_confirm_mail_text',
            emailLabelFocus: '.mobile_label_focus',
            groupMobileLabels: '.group_mobile_labels',
            nonEditableLayerFields: '[data-noneditable-layer]',
            hideOnUserLogged: '.hide_on_user_logged',
            fillBuyerCombo: '.fill_buyer_combo_section',
            travellerTitleWarning: '.traveller_title_warning',
            buyerEditableValidationMail: '.buyer_editable_validation_mail',
            buyerValidationMail: 'input[data-name="validationMail"]',
            apisContainer: '.apis_container',
            showApisRequests: '.show_apis_requests',
            apisRequestsWrapper: '.passengersmanager_apis_requests_wrapper',
            zipCode: '[data-name="zipCode"]',
            buyerCountry: '[data-name="country"]',
            clickError: '.click_error',
            passwordInput: '[data-name="password"]',
            passwordBox: '.password_box',
            passwordIcon: '.password_char_viewer',
            bDayInputs: '.input_wrapper_birth .select_day, input_wrapper_birth .select_month, .input_wrapper_birth .select_year',
            showOptionalRequests: '.show_optional_requests',
            moreOptionsBlock: '.moreoptions_block',
            passengerCardNumber: '.passenger_card_number',
            fflyerCodesSection: '.fflyer_codes_section',
            mealsSelector: 'select[data-name="meal"]',
            apisRequestsWrapperInputs: '.passengersmanager_apis_requests_wrapper [data-name]',
            baggageType: '[data-fieldtype="baggageType"]',
            allNamesInput: '[data-name="name"]',
            allInputs: 'input[data-name]:not([type="hidden"]), select[data-name]:not([type="hidden"])',
            visibleDateFields: '.input_wrapper_birth:visible .date',
            membershipSignal: '.membership_signal',
            membershipExtraInfo: '.membership_extra_information',
            selectOptionMember: '.select_option_member',
            paxSelectorLabel: '.pax_selector_label',
            paxSeparatorTitle: '.pax_separator_title',
            stateNameContainer: '.stateNameContainer',
            googlePlacesAutocompleteInput: 'input[data-name="address"]',
            primeInPaymentForceLogin: '.prime_in_payment_force_login',
            forceLoginButton: '.force_login_button',
            closeForceLogin: '.close_force_login',
            dropdownSelect: '.dropdown_select_with_input',
            dropdownOption: '.dropdown_select_option',
            dropdownFirstOption: '.dropdown_first_option',
            dropdownTelephone: '.dropdown_telephone',
            dropdownFlag: '.dropdown_flag',
            fullResidentName: '[data-name="name"], [data-name="firstLastName"], [data-name="secondLastName"]',
            residentLastNames: '[data-name="firstLastName"], [data-name="secondLastName"]',
            removePax: '.details_change_pax_button',
        },
        // save DOM selectors to the widget cache
        cacheDomSelectors: function() {
            this.addSelectorToCache('nonEditableBuyerLayer', Odigeo.UIElements.collapsive.enhance(this.$el.find('.non_editable_buyer_layer')));
            this.addSelectorToCache(
                'editableBuyerLayer',
                Odigeo.UIElements.collapsive.enhance(this.$el.find('.editable_buyer_layer'), {initiallyExpanded: true})
            );

            this.addSelectorToCache(
                'editableBuyerLayerWidget',
                Odigeo.UIElements.collapsive.enhance(this.$el.find('.editable_buyer_layer_widget'), {initiallyExpanded: true})
            );
            this.addSelectorToCache(
                'toggleOptionalRequest',
                Odigeo.UIElements.collapsive.enhance(this.$el.find('.passengersmanager_optional_requests'), {
                    googleAnalyticsOnOpen: {
                        type: 'trackEvent',
                        data: {
                            page: Odigeo.History.getPageNameFromFragment(),
                            action: 'optional_requests_open',
                            label: 'optional_requests',
                        },
                    },
                })
            );
            this.addSelectorToCache(
                'toggleApisRequest',
                Odigeo.UIElements.collapsive.enhance(this.$cachedSelectors.apisRequestsWrapper, {
                    googleAnalyticsOnOpen: {
                        type: 'trackEvent',
                        data: {
                            page: Odigeo.History.getPageNameFromFragment(),
                            action: 'apis_requests_open',
                            label: 'apis_requests',
                        },
                    },
                })
            );
            this.addSelectorToCache(
                'passengerInputs',
                this.$el
                    .find('[data-name]')
                    .not(this.$cachedSelectors.apisRequestsWrapperInputs)
                    .not(this.$cachedSelectors.passengerCardNumber)
                    .not(this.$cachedSelectors.baggageType)
                    .not(this.$cachedSelectors.passengerInputsOptional)
            );
            this.addSelectorToCache('passengerFullInputs', this.$el.find('[data-name]').not(this.$cachedSelectors.baggageType));
            this.addSelectorToCache('ffyerButton', this.$el.find('#showFlyerOptions' + this.widget.options.index));
        },

        updatePassengerIdentificationType: function(identificationType) {
            var passengerIdentificationType = !Odigeo._.isNull(identificationType)
                ? identificationType
                : this.$cachedSelectors.identificationType.val();
            this.$cachedSelectors.identificationType.val(passengerIdentificationType);
            this.identificationTypeValidations();
        },

        identificationTypeValidations: function() {
            var identification = this.$cachedSelectors.identificationType.val();
            var selectedValidation = 'NULL_VALIDATOR';
            var isNifValidation = identification === 'NIF';

            if (['NIF', 'NIE', 'CIF', 'PASSPORT', 'NATIONAL_ID_CARD'].indexOf(identification) > -1) {
                selectedValidation = 'IDENTIFICATION_VALIDATOR_' + identification;
            }

            if (isNifValidation) {
                this.$cachedSelectors.passangermanagerSecondLastName.attr('required', 'required').removeClass('optional');
            } else {
                this.$cachedSelectors.passangermanagerSecondLastName.removeAttr('required').addClass('optional');
            }

            this.$cachedSelectors.passangermanagerSecondLastNameWrapper.toggleClass('hidden', !isNifValidation);
            this.$cachedSelectors.identification.data('validationType', selectedValidation);
            this.$cachedSelectors.identification.data('pattern', this.$cachedSelectors.identificationType.find(':selected').attr('data-pattern'));
        },

        firstLastNameLabelSwitch: function() {
            if (this.isResident()) {
                this.$el.find('span[data-label-name="firstLastName"]').html(Odigeo.UIElements.translations.passengersManager.residencyFirstLastName);
            }
        },

        showStateName: function(country) {
            var options = this.widget.options;
            var countries = options.nonHidableStateNameCountry ? options.nonHidableStateNameCountry.split(',') : [];
            var isStateNameHidable = options.isStateNameHidable && !Odigeo._.includes(country, countries);
            this.$cachedSelectors.stateName.toggleClass('optional', isStateNameHidable);
            this.$cachedSelectors.stateNameContainer.toggleClass('odf-hidden', isStateNameHidable);
        },

        getPhonecodeFromSession: function() {
            const sessionStorageBuyer = Odigeo.Utils.parseJson(Odigeo.Session.get('passengersData')) || {};
            const buyer = sessionStorageBuyer.buyer || {};
            return (
                buyer.phoneCode1 ||
                this.$cachedSelectors.dropdownTelephone
                    .find('option')
                    .eq(1)
                    .data('value')
            );
        },

        getInitTelephoneCode: function() {
            const phoneCode = this.getPhonecodeFromSession();
            const $option = phoneCode
                ? this.$cachedSelectors.dropdownOption.filter(`[data-value="${phoneCode.toUpperCase()}"]`)
                : this.$cachedSelectors.dropdownOption;
            const telephoneCode = this.getPhoneCode($option.val());
            this.$cachedSelectors.dropdownFirstOption
                .text(telephoneCode[0])
                .attr('value', phoneCode.toUpperCase())
                .prop('selected', true);
            this.getFlagDropDown(this.$cachedSelectors.dropdownTelephone);
        },

        getPhoneCode: function(telephone) {
            return (telephone && telephone.match(/(\+\d{1,4})(\s\d{1,4})?/)) || [];
        },

        getCountryFlag: function($data) {
            const telephone = $data
                .find(':selected')
                .text()
                .trim();
            const telephoneCode = this.getPhoneCode(telephone);
            this.$cachedSelectors.dropdownFirstOption.text(telephoneCode[0]);
            const val = $data.find(':selected').attr('value') || $data.find(':selected').data('value');
            return val.toLowerCase();
        },

        changeFlag: function(country) {
            this.$cachedSelectors.dropdownFirstOption.attr('value', country.toUpperCase()).prop('selected', true);
            const currentFlag = this.$cachedSelectors.dropdownFlag.attr('data-flag');
            this.$cachedSelectors.dropdownFlag.removeClass(`odf-flag-${currentFlag}`).addClass(`odf-flag-${country}`);
            this.$cachedSelectors.dropdownFlag.attr('data-flag', country);
        },

        getFlagDropDown: function($data) {
            if ($data.val()) {
                const country = this.getCountryFlag($data);
                this.changeFlag(country);
                this.storeLocalData(false);
            } else {
                this.getInitTelephoneCode();
            }
        },

        showForcePrimeLoginIndicator: function(discountSelected) {
            this.widget.model.set('discountSelected', discountSelected);
            const buyerEditableValidationMail = this.$cachedSelectors.buyerEditableValidationMail;
            this.$cachedSelectors.primeInPaymentForceLogin.addClass('open opened');
            this.$cachedSelectors.buyerEmail.closest('.validation_field').addClass('invalid');
            buyerEditableValidationMail.val('');
            buyerEditableValidationMail.closest('.validation_field').toggleClass('valid focused');
            this.highlightEmail();
            const primeLabel = discountSelected ? 'prime' : 'no-prime';
            trackingUtils.trackEvent('unlocked', `unlocked_existing_account_sce:${primeLabel}`);
        },

        closeForceLoginPopup: function() {
            this.$cachedSelectors.primeInPaymentForceLogin.removeClass('open opened');
            const primeLabel = this.widget.model.get('discountSelected') ? 'prime' : 'no-prime';
            trackingUtils.trackEvent('unlocked', `unlocked_existing_account_close_sce:${primeLabel}`);
            Odigeo.trigger(this.widget.name + ':closeForceLoginPopup');
        },

        openLoginPopup: function() {
            this.$cachedSelectors.primeInPaymentForceLogin.removeClass('open opened');
            const primeLabel = this.widget.model.get('discountSelected') ? 'prime' : 'no-prime';
            trackingUtils.trackEvent('unlocked', `unlocked_go_to_login_sce:${primeLabel}`);
            Odigeo.trigger(this.widget.name + ':openLoginForm');
            Odigeo.trigger(this.widget.name + ':closeForceLoginPopup');
        },

        defaultNifSelection: function() {
            var residentSelector = this.$el.find('select[data-name="localityCodeOfResidence"]');
            if (residentSelector.length > 0) {
                // update the localityName input to populate it in backend
                residentSelector.off('change').on(
                    'change',
                    Odigeo._.bind(function(ev) {
                        this.$el.find('input[data-name="localityNameOfResidence"]').val(ev.target[ev.target.selectedIndex].label);
                    }, this)
                );
                // init the first time
                residentSelector.val(residentSelector[0][residentSelector[0].selectedIndex].value);
                this.$el.find('input[data-name="localityNameOfResidence"]').val(residentSelector[0][residentSelector[0].selectedIndex].label);
                this.selectNifByDefault();
            } else if (this.widget.options.showNifByDefault) {
                this.selectNifByDefault();
            }
        },

        selectNifByDefault: function() {
            const $nifOption = this.$el.find('select[data-name="identificationType"] option[value="NIF"]');
            if ($nifOption.length > 0) {
                $nifOption.prop('selected', true).trigger('change');
            }
        },

        showEmail: function(shallShow) {
            this.$cachedSelectors.buyerEditableEmail.toggleClass('odf-hidden', !shallShow);
        },

        highlightEmail: function() {
            Odigeo.Utils.scrollToElement(this.$cachedSelectors.buyerEmail);
        },

        showHideConfirmEmailText: function(isValidMail) {
            if (isValidMail) {
                this.$cachedSelectors.buyerConfirmEmailText.addClass('od-show-confirm-mail-text');
                this.$cachedSelectors.emailLabelFocus.addClass('od-hide-label-focus');
                this.$cachedSelectors.groupMobileLabels.addClass('od-label-confirm-text');
            } else {
                this.$cachedSelectors.buyerConfirmEmailText.removeClass('od-show-confirm-mail-text');
                this.$cachedSelectors.emailLabelFocus.removeClass('od-hide-label-focus');
                this.$cachedSelectors.groupMobileLabels.removeClass('od-label-confirm-text');
            }
        },

        buyerValidation: function() {
            var selectedValidation = 'NULL_VALIDATOR';
            if (!this.widget.options.isBuyer) {
                return;
            }
            if (['NIF', 'NIE', 'CIF', 'PASSPORT', 'NATIONAL_ID_CARD'].indexOf(this.$cachedSelectors.buyerIdentificationType.val()) > -1) {
                selectedValidation = 'IDENTIFICATION_VALIDATOR_' + this.$cachedSelectors.buyerIdentificationType.val();
            }
            var regex = this.$cachedSelectors.buyerIdentificationType.find(':selected').attr('data-pattern');
            this.$cachedSelectors.identification
                .val('')
                .data('validationType', selectedValidation)
                .data('pattern', regex);
        },

        _reCacheAndBindAllInputs: function() {
            this.updateDomSelectorsToCache();
            this._reBindInputs();
        },

        _reBindInputs: function() {
            var optionHandlerPairs = {
                blurValidationEvent: {
                    handler: this._inputBlurHandler,
                    target: this.$cachedSelectors.allFocused,
                },
                progressiveValidationEvent: {
                    handler: this._validateUntilField,
                    target: this.$cachedSelectors.allInputs,
                },
                selectValidationEvent: {
                    handler: this._inputBlurHandler,
                    target: this.$cachedSelectors.allInputs.filter('select'),
                },
                resetInputStateEvent: {
                    handler: Odigeo._.throttle(this._handleChangeText, 350, {trailing: false}),
                    target: this.$cachedSelectors.allInputs.filter('input[type="text"], input[type="email"]'),
                },
            };

            this.$cachedSelectors.allInputs.off(Odigeo.Events.focus);
            Odigeo._.each(
                optionHandlerPairs,
                function(handleTargetPair, option) {
                    handleTargetPair.target.on(
                        Odigeo._.map((this.widget.options[option] || '').split(' '), function(event) {
                            return Odigeo._.isEmpty(event) ? undefined : handleTargetPair.target.off(event), Odigeo.Events[event] || '';
                        }).join(' '),
                        Odigeo._.bind(handleTargetPair.handler, this)
                    );
                },
                this
            );

            this.$cachedSelectors.allFocused.on(Odigeo.Events.focus, Odigeo._.bind(this._focusHandler, this));
            this.$cachedSelectors.passwordIcon.on(Odigeo.Events.tap, Odigeo._.bind(this._togglePasswordVisibility, this));
        },

        bindToDom: function() {
            var onBlurBuyerEmail = Odigeo._.bind(function(evt) {
                var $el = $(evt.currentTarget);
                var value = $el.val();
                if (this.widget.model.checkValidity($el) && !Odigeo.AB.isNewNewsletterLogic) {
                    this.widget.model.crmSubscribeCustomerEmail(value);
                }
                if (!Odigeo._.isEmpty(this.$cachedSelectors.buyerValidationMail.val())) {
                    var isValidValidationMail = this.widget.model.checkValidity(this.$cachedSelectors.buyerValidationMail);
                    this.$cachedSelectors.buyerValidationMail
                        .closest('.validation_field')
                        .toggleClass('valid', isValidValidationMail)
                        .toggleClass('invalid', !isValidValidationMail);
                }
            }, this);

            if (this.isDomBinded) {
                return;
            }
            // enhance tooltips
            Odigeo._.each(
                this.$el.find('.tooltip_hint_wrapper'),
                function(el) {
                    var $el = $(el);
                    var tooltip = Odigeo.UIElements.enhanceTooltip($el.find('.tooltips_hint_container'));

                    $el.find('.open_hint').on(Odigeo.Events.tap, function(event) {
                        tooltip.show();
                        event.stopPropagation();
                    });
                },
                this
            );

            this.$widget
                .on(
                    Odigeo.Events.change,
                    'input[type="radio"]',
                    Odigeo._.bind(function() {
                        this.storeLocalData(false);
                    }, this)
                )
                .on(
                    Odigeo.Events.tap,
                    '.calendar',
                    Odigeo._.bind(function(evt) {
                        var $calendar = $(evt.currentTarget).find('.calendar_input');
                        this._toggleCalendar($calendar, true, true);
                    }, this)
                )
                .on(
                    Odigeo.Events.change,
                    '.calendar_input',
                    Odigeo._.bind(function(evt) {
                        var $el = $(evt.currentTarget);
                        if (!Odigeo._.isEmpty($el.val())) {
                            $el.siblings('.calendar_placeholder').addClass('hidden');
                        }
                    }, this)
                )
                .on(
                    Odigeo.Events.change,
                    '.select_input[data-pax-index="' + this.widget.options.index + '"]',
                    Odigeo._.bind(function(evt) {
                        var $el = $(evt.currentTarget);
                        var selectedBaggage = $el.find('option').filter(':selected');
                        var baggageQuantity = selectedBaggage.data('numbags');
                        var isSegment = $el.data('applicationlevel') === this.getBaggagesApplicationLevelEnum().segment;
                        var segmentIndex = isSegment ? $el.data('segmentindex') : '';
                        var dataIndex = $el.attr('data-index');
                        var price = selectedBaggage.data('price');
                        var kilos = selectedBaggage.data('kilos');

                        if (baggageQuantity > 0) {
                            $el.parent()
                                .parent()
                                .parent()
                                .find('.baggage_selector')
                                .toggleClass('hidden', true);
                            $el.parent()
                                .parent()
                                .parent()
                                .find('.baggage_reset')
                                .toggleClass('hidden', false);
                        }

                        this.widget.model.set({selectedBaggageQuantity: this.widget.model.get('selectedBaggageQuantity') + baggageQuantity});
                        this._dataChangedHandler();
                        Odigeo.trigger(this.widget.name + ':baggageChange', {
                            type: 'baggage',
                            id: this.widget.id,
                            index: dataIndex,
                            data: {
                                price: parseFloat(price || 0),
                                quantity: parseFloat(baggageQuantity || 0),
                                segmentIndex: segmentIndex,
                                kilos: kilos,
                            },
                        });
                        $el.data('prev-kilos', selectedBaggage.data('kilos'));
                    }, this)
                )
                .on(
                    Odigeo.Events.tap,
                    '.baggage_selector',
                    Odigeo._.bind(function(evt) {
                        var index = evt.target.getAttribute('data-index');
                        this.$el.find('.baggage_type_wrapper_' + index).toggleClass('hidden', false);
                        this.$el
                            .find('.baggage_type_wrapper')
                            .not('.baggage_type_wrapper_' + index)
                            .toggleClass('hidden', true);
                    }, this)
                )
                .on(
                    Odigeo.Events.tap,
                    '.baggage_reset',
                    Odigeo._.bind(function(evt) {
                        var $el = $(evt.currentTarget);
                        var $select = this.$el.find('.js_baggageType_' + $el.attr('data-index'));
                        var baggageQuantity;
                        var segmentIndex;
                        var price;
                        var firstOption = $select.find('option').filter(':first');
                        var kilos;
                        var currentBaggage = $select
                            .find('option')
                            .filter(':selected')
                            .data().numbags;
                        $el.siblings('.baggage_selector').toggleClass('hidden', false);
                        $el.toggleClass('hidden', true);
                        this.$el.find('.baggage_type_wrapper').toggleClass('hidden', true);

                        firstOption.attr('selected', true);
                        $select.val(firstOption.val());

                        baggageQuantity = $select
                            .find('option')
                            .filter(':selected')
                            .data('numbags');

                        segmentIndex = $select.data('segmentindex');
                        price = $select
                            .find('option')
                            .filter(':selected')
                            .data('price');
                        kilos =
                            $select.data('prev-kilos') ||
                            $select
                                .find('option')
                                .filter(':selected')
                                .data('kilos');

                        var storedBaggage = this.widget.model.get('selectedBaggageQuantity');
                        this.widget.model.set({selectedBaggageQuantity: storedBaggage > 0 ? storedBaggage - currentBaggage : 0});
                        Odigeo.trigger(this.widget.name + ':baggageChange', {
                            type: 'baggage',
                            id: this.widget.id,
                            index: $el.attr('data-index'),
                            data: {
                                price: parseFloat(price),
                                quantity: parseFloat(baggageQuantity),
                                segmentIndex: segmentIndex,
                                kilos: kilos,
                            },
                        });
                        $select.data(
                            'prev-kilos',
                            $select
                                .find('option')
                                .filter(':selected')
                                .data('kilos')
                        );
                    }, this)
                )
                .on(
                    Odigeo.Events.tap,
                    '.clear_input',
                    Odigeo._.bind(function(e) {
                        this.fieldUtils.clearField(e);
                    }, this)
                );

            this.$cachedSelectors.showApisRequests.on(
                Odigeo.Events.change,
                Odigeo._.bind(function() {
                    this.$cachedSelectors.toggleApisRequest.trigger('togglePanel', {
                        isOpenedAutomatic: this.$cachedSelectors.showApisRequests.is(':checked'),
                    });
                    this.$cachedSelectors.apisRequestsWrapper.find('.validation_field').removeClass('invalid empty');
                }, this)
            );

            this.$cachedSelectors.moreOptionsBlock.on(
                Odigeo.Events.change,
                Odigeo._.bind(function() {
                    this.$cachedSelectors.toggleOptionalRequest.trigger('togglePanel', {
                        isOpenedAutomatic: this.$cachedSelectors.showOptionalRequests.is(':checked'),
                    });
                    if (this.$cachedSelectors.showOptionalRequests.is(':checked')) {
                        trackingUtils.trackEvent('frequent_flyer_widget', 'frequent_flyer_widget_click_open');
                    }
                }, this)
            );

            this.$cachedSelectors.passengerCardNumber.on(Odigeo.Events.change, Odigeo._.bind(this.validFrequentCardNumberTracking, this));
            this.$cachedSelectors.mealsSelector.on(Odigeo.Events.change, Odigeo._.bind(this.selectedMealTracking, this));

            this.$cachedSelectors.ffyerButton.on(
                Odigeo.Events.change,
                Odigeo._.bind(function() {
                    this.$cachedSelectors.fflyerCodesSection.toggleClass('odf-hidden', !this.$cachedSelectors.ffyerButton.is(':checked'));
                }, this)
            );

            this._reBindInputs();

            this.$cachedSelectors.passengerTypeSelector.on(Odigeo.Events.change, Odigeo._.bind(this._passengerSelectorHandler, this));

            this.$cachedSelectors.storedPassengers.on(Odigeo.Events.change, Odigeo._.bind(this._storedPassengersChangeHandler, this));

            this.$cachedSelectors.storePassengerCheckbox.on(
                Odigeo.Events.change,
                Odigeo._.bind(function(evt) {
                    var analyticsPrefix = this.widget.options.isBuyer ? 'buyer_' : 'pax_';
                    var analyticsPaxPosition = !this.widget.options.isBuyer ? this.widget.id[this.widget.id.length - 1] + '_' : '';

                    // Analytics: event tracking
                    trackingUtils.trackEventWithCategory(
                        'flights_pax_page',
                        analyticsPrefix + 'details',
                        'save_' + analyticsPrefix + analyticsPaxPosition + 'info_' + (evt.target.checked ? 'checked' : 'unchecked')
                    );

                    this.widget.options.storageEnabled = evt.target.checked;
                }, this)
            );

            this.$cachedSelectors.addDocumentBtn.on(Odigeo.Events.tap, Odigeo._.bind(this._addDocumentSectionHandler, this));

            this.$cachedSelectors.selectsPlaceholder.on(
                Odigeo.Events.change,
                Odigeo._.bind(function(evt) {
                    var $el = $(evt.currentTarget);

                    this._toggleSelect($el);
                }, this)
            );

            this.$cachedSelectors.selectField.on(
                Odigeo.Events.change,
                Odigeo._.bind(function(evt) {
                    $(evt.currentTarget)
                        .closest('.validation_field')
                        .removeClass('focused');
                    if ($(evt.currentTarget).val() === 'NIE' && this.model.passengerSelectedId === 0 && this.isResident()) {
                        this._populateName();
                    }
                }, this)
            );

            this.$cachedSelectors.identificationType.on(
                Odigeo.Events.change,
                Odigeo._.bind(function(evt) {
                    if ($(evt.currentTarget).val() === 'NIE' && this.model.passengerSelectedId === 0 && this.isResident()) {
                        this._populateName();
                    }
                }, this)
            );

            Odigeo.bind(this.widget.id + ':refreshPassengerSelector', Odigeo._.bind(this.refreshPassengerSelector, this));

            Odigeo.bind(this.widget.id + ':setPassenger', Odigeo._.bind(this._setSelectedPassenger, this));

            if (Odigeo.Device.navigator.isSafariiOS) {
                this.$cachedSelectors.allCalendars.addClass('is-safari');
            }

            // Bind blur event to send custom_email param to TagCommander asap when it's been validated
            if (this.widget.options.isBuyer) {
                this.$cachedSelectors.buyerEmail.off(Odigeo.Events.blur, onBlurBuyerEmail).on(Odigeo.Events.blur, onBlurBuyerEmail);

                this.bindAutocompleteMailEvents();

                this.$cachedSelectors.buyerEditableValidationMail.on(Odigeo.Events.paste, function(evt) {
                    evt.preventDefault();
                });

                this.$cachedSelectors.buyerValidationMail.on(
                    Odigeo.Events.blur,
                    Odigeo._.bind(function(evt) {
                        var $el = $(evt.currentTarget);
                        if (this.widget.model.checkValidity($el)) {
                            this.$cachedSelectors.buyerEditableValidationMail.find('.validation_field').removeClass('valid invalid empty');
                        }
                    }, this)
                );

                this.$cachedSelectors.editBuyerInfoButton.off().on(Odigeo.Events.tap, Odigeo._.bind(this.hideNonEditableBuyerLayer, this, true));
            }

            var $inputs = $()
                .add(this.$cachedSelectors.allInputs)
                .add(this.$cachedSelectors.bDayInputs);

            Odigeo._.each(
                $inputs,
                function(input) {
                    var $input = $(input);

                    $input
                        .on(
                            Odigeo.Events.focus,
                            Odigeo._.bind(function() {
                                this.fieldUtils.showHidePlaceholder($input, true);
                                $input
                                    .closest('.validation_field')
                                    .removeClass('empty invalid valid')
                                    .attr('data-state', 'init');
                            }, this)
                        )
                        .on(Odigeo.Events.blur, Odigeo._.partial(this.fieldUtils.showHidePlaceholder, $input, false));
                },
                this
            );

            this.isDomBinded = true;
        },

        expandPassengerContainer: function(isCollapsed) {
            this.expandPassenger();
            this.$cachedSelectors.passengerContainer.toggleClass('collapsed', !isCollapsed);
        },
        expandWithCards: function(isCollapsed) {
            const customerSelector = this.$cachedSelectors.customerSelector.find(optionNotSelected).length;
            if (customerSelector !== 1) {
                Odigeo.trigger(`${this.widget.name}:toggleSheetCardPassengers`, this.widget.options.index);
            } else if (isCollapsed) {
                this.expandPassengerContainer(isCollapsed);
            }
        },
        expand() {
            const isCollapsed = this.$cachedSelectors.passengerContainer.hasClass('collapsed');
            this.$cachedSelectors.passengerContainer.removeClass('init');

            if (isCollapsed && !this.model.user) {
                this.expandPassengerContainer(isCollapsed);
            } else {
                this.expandWithCards(isCollapsed);
            }
        },

        collapse(id) {
            if (id !== this.widget.id && !this.$cachedSelectors.passengerContainer.hasClass('collapsed') && !this.widget.hasErrors()) {
                this.collapsePassenger();
                this.$cachedSelectors.passengerContainer.addClass('collapsed');
            }
        },
        setAcronymAndTitle: function(name, firstLastName) {
            this.$cachedSelectors.acronymCircle.addClass('show');
            if (name[0] && firstLastName[0]) {
                this.$cachedSelectors.acronymText.html(name[0].toUpperCase() + firstLastName[0].toUpperCase());
                this.$cachedSelectors.paxNameTitle.html([name, firstLastName].join(' ').trim());
            }
        },
        toggleEditAndAddTexts(toggle) {
            this.$cachedSelectors.changePax.toggleClass('show', toggle).toggleClass('odf-hidden', !toggle);
        },
        collapsePassenger() {
            const form = this.$cachedSelectors.passengerForms[0];
            this.toggleEditAndAddTexts(false);

            if (form) {
                return collapsibleBox.collapse(form).then(() => {
                    if (this._validateAllFields(true, null, true)) {
                        this.toggleEditAndAddTexts(true);
                        this.$cachedSelectors.passengerContainer.removeClass('init');
                        this.setAcronymAndTitle(this.$cachedSelectors.name.val(), this.$cachedSelectors.firstLastName.val());
                    }
                });
            }
        },

        expandPassenger(silent = false, id) {
            const form = this.$cachedSelectors.passengerForms[0];

            if (!silent) {
                Odigeo.trigger(`${this.widget.name}:openPaxBox`, this.widget.id, true);
            }

            this.$cachedSelectors.acronymCircle.removeClass('show');
            this.toggleEditAndAddTexts(false);
            this.$cachedSelectors.membershipTitle.toggleClass('odf-hidden', id !== 0);
            this.$cachedSelectors.loggedInUser.toggleClass('odf-hidden', id === 0 || id === undefined);
            return collapsibleBox.expand(form).then(() => {
                this.$cachedSelectors.passengerContainer.removeClass('collapsed');
            });
        },

        onValidationEmailChange: function(name, e) {
            this.model.set(name, e.target.value);
        },
        residentDiscountAppliedChanged() {
            const residentDiscountApplied = this.model.get('residentDiscountApplied');
            this.$cachedSelectors.residentDiscountAlert.toggleClass('odf-hidden', !residentDiscountApplied);
        },

        onValidationEmailModelChange: function(model, value) {
            emailSuggestion.checkEmailValueByText('validationMail', value);
        },

        bindAutocompleteMailEvents: function() {
            if (this.$cachedSelectors.buyerEmail.length) {
                emailSuggestion.initEmailSuggestion(
                    'email',
                    this.$cachedSelectors.buyerEmail,
                    this.$cachedSelectors.suggestionMail,
                    this.$cachedSelectors.passengerHeader
                );
            }
        },

        unbindFromDom: function() {
            $(window).off('resize');

            this.$widget.off(Odigeo.Events.tap, '.calendar').off(Odigeo.Events.blur, '.calendar_input');
            this.$cachedSelectors.allInputs.off(Odigeo.Events.blur);
            this.$cachedSelectors.storedPassengers.off(Odigeo.Events.change);
            this.$cachedSelectors.storePassengerCheckbox.off(Odigeo.Events.change);
            this.$cachedSelectors.buyerEmail.off();

            Odigeo.unbind(this.widget.id + ':refreshPassengerSelector');

            this.isDomBinded = false;
        },

        clearForm: function(passengerTypeByDefault) {
            // Clear prices
            Odigeo._.each(
                this.$el.find('.js_baggageType[data-fieldtype="baggageType"]'),
                function(el) {
                    var $el = $(el);
                    $el.val(0);
                    this.widget.model.set({selectedBaggageQuantity: 0});
                    Odigeo.trigger('passengers_manager' + ':baggageChange', {
                        type: 'baggage',
                        id: this.widget.id,
                        index: $el.attr('data-index'),
                        data: {
                            price: 0,
                            quantity: 0,
                            segmentIndex: $el.attr('data-segmentindex'),
                            kilos: $el.attr('data-kilos'),
                        },
                    });
                },
                this
            );
            // Clear inputs
            this.$cachedSelectors.allInputs
                .filter(':not(select)')
                .val('')
                .end()
                .filter('[data-name="travellerType"]')
                .val('ADULT');

            this.$cachedSelectors.allInputs.filter('select').each(function(index, el) {
                el.selectedIndex = 0;
            });

            if (this.$cachedSelectors.documentsContainer.hasClass('add_section')) {
                this.$cachedSelectors.documentsContainer
                    .children()
                    .not('.add_section_btn')
                    .filter(':visible')
                    .remove();
            }

            if (this.$cachedSelectors.fflyerContainer.hasClass('add_section')) {
                this.$cachedSelectors.fflyerContainer
                    .children()
                    .not('.add_section_btn, .hidden')
                    .remove();
                this.$cachedSelectors.fflyerContainer.find('.add_section_btn').removeClass('hidden');
            }

            this.$cachedSelectors.passengerFields.removeClass('valid invalid empty');

            this._correctBirthdayInput(passengerTypeByDefault ? 'adults' : this.widget.options.travellerType);

            // Clear FFC and documents mini-forms
            this._refreshInputs();
        },

        refreshPassengerSelector: function() {
            var options = [];
            var storedPassengers = Odigeo.Utils.parseJson(Odigeo.Storage.get('travellers'));
            var $selectBuyerStored = $('#buyer').find('.stored_passengers select');
            var defaultTravellerID;

            if (storedPassengers && storedPassengers.defaultTraveler && storedPassengers.defaultTraveler.id) {
                defaultTravellerID = storedPassengers.defaultTraveler.id;
            }

            Odigeo._.each(
                this.widget.model.readAllPassengers()[this.widget.options.travellerType],
                Odigeo._.bind(function(pass, id) {
                    options.push({
                        id: id,
                        name: [pass.name, pass.firstLastName || pass.lastName].join(' ').trim(),
                    });
                }, this)
            );

            options.sort(function(a, b) {
                if (a.id === defaultTravellerID) {
                    return -1;
                }
                if (b.id === defaultTravellerID) {
                    return 1;
                }
                if (a.name < b.name) {
                    return -1;
                }
                if (a.name > b.name) {
                    return 1;
                }

                return 0;
            });

            this.$cachedSelectors.storedPassengers.off(Odigeo.Events.change);

            this.$cachedSelectors.storedPassengers.children(':not([value=""])').remove();

            Odigeo._.each(
                options,
                function(item) {
                    $('<option>', {
                        value: item.id,
                        text: item.name,
                    }).appendTo(this.$cachedSelectors.storedPassengers);
                },
                this
            );

            this.$cachedSelectors.storedPassengers.val(this.widget.model.passengerID);

            this.$cachedSelectors.storedPassengersWrapper.toggleClass('hidden', !options.length);

            if (options.length) {
                this.$cachedSelectors.storedPassengers.on(Odigeo.Events.change, Odigeo._.bind(this._storedPassengersChangeHandler, this));
                if (!Odigeo._.isEmpty($selectBuyerStored.val())) {
                    $selectBuyerStored.trigger(Odigeo.Events.change);
                }
            }
        },

        collectPassengerData: function() {
            var passenger = {};
            var collectFields = function(memo, el) {
                var $el = $(el);
                var isRadio = $el.prop('type') === 'radio';
                var dataName = $el.attr('data-name');
                if (!Odigeo._.isEmpty($el.val()) && (!isRadio || (isRadio && $el.prop('checked')))) {
                    memo[dataName] = Odigeo._.startsWith(dataName, 'phoneNumber') ? $el.val().replace(/[\s()-]/g, '') : $el.val();
                } else if ($el.hasClass('radio_group') && $el.find('input:checked')) {
                    memo[dataName] = $el.find('input:checked').val();
                }
                return memo;
            };

            passenger = Odigeo._.reduce(this.$cachedSelectors.passengerInputs, collectFields, passenger, this);
            if (this.$cachedSelectors.middleName.length && !Odigeo._.isEmpty(this.$cachedSelectors.middleName?.[0]?.value)) {
                passenger.name = `${passenger.name} ${this.$cachedSelectors.middleName?.[0]?.value}`;
            }
            if (this.widget.options.isBuyer && !Odigeo._.isEmpty(this.$cachedSelectors.passwordInput.val())) {
                passenger.password = this.$cachedSelectors.passwordInput.val();
            }

            if (this.$cachedSelectors.showApisRequests.is(':checked')) {
                var advancedPaxInformation = {};
                advancedPaxInformation = Odigeo._.reduce(
                    this.$cachedSelectors.apisRequestsWrapperInputs,
                    collectFields,
                    advancedPaxInformation,
                    this
                );
                passenger = Odigeo._.extend(passenger, advancedPaxInformation);
            }

            if (!this.widget.options.isBuyer) {
                passenger.frequentFlyerCardCodes = [];
                if (this.$cachedSelectors.showOptionalRequests.is(':checked')) {
                    Odigeo._.each(
                        this.$cachedSelectors.passengerCardNumber,
                        function(passengerCardNumber) {
                            var $passengerCardNumber = $(passengerCardNumber);
                            if (this.model.checkValidity($passengerCardNumber, true)) {
                                passenger.frequentFlyerCardCodes.push({
                                    carrierCode: $passengerCardNumber.data('carrierCode'),
                                    passengerCardNumber: $passengerCardNumber.val(),
                                });
                            }
                        },
                        this
                    );
                }

                passenger.baggageSelectionDTOs = this.parseBaggagesDTOs();
                const baggageCollectionBuilderData
                    = (baggageCollectionBuilder.baggagesOptionsModel.getAll() || {})?.baggage || {};
                const areAllPassengersWithBaggage
                    = baggageCollectionBuilder.areAllPassengersWithBaggage(baggageCollectionBuilderData);
                baggageOptionsCollection.updateTotalInCartFromTotalPrice(areAllPassengersWithBaggage);
            } else {
                const $dropdownSelected = this.widget.view.$el.find('.dropdown_select_selected');
                if ($dropdownSelected.length) {
                    $dropdownSelected.each(function() {
                        const $item = $(this);
                        passenger[$item.data('name')] = $item.find('.select_value').data('value');
                    });
                }
            }

            return {
                data: passenger,
                passengerID: this.widget.model.passengerID,
            };
        },

        parseBaggagesDTOs: function() {
            var baggagesSelectedInfo = this.widget.getBaggagePassengerComposedRowsInfo(this.widget.options.index);

            return Odigeo._.map(
                baggagesSelectedInfo.filter(({options}) => Array.isArray(options) && options.length > 0),
                function(rowSelectedInfo) {
                    var selected = rowSelectedInfo.selected;

                    if (selected) {
                        var isSelectable = selected.get('isSelectableBaggage');
                        var isIncluded = selected.get('isIncludedBaggage');
                        var descriptor = {};
                        var descriptorIncluded = {};

                        selected = selected.getDescriptor();

                        if (isSelectable) {
                            descriptor = selected;
                        } else if (isIncluded) {
                            descriptorIncluded = selected;
                        }
                    } else {
                        descriptor = {pieces: 0, kilos: 0, price: 0};
                    }

                    return {
                        selectedBaggageDescriptor: [
                            {
                                baggageDescriptor: descriptor,
                                price: descriptor.price,
                            },
                        ],
                        baggageDescriptorIncludedInPrice: descriptorIncluded,
                        segmentTypeIndexDTO: rowSelectedInfo.rowDescriptor.get('idRow'),
                    };
                },
                this
            );
        },

        fillPassengerData: function(passenger) {
            var fields = {};
            var $documentSection = this.$cachedSelectors.documents;

            if (Odigeo._.isNull(passenger) || Odigeo._.isUndefined(passenger)) {
                return;
            }

            if (this.widget.options.isBuyer) {
                passenger.lastName = passenger.lastName || passenger.firstLastName || '';
            } else {
                passenger.firstLastName = passenger.firstLastName || passenger.lastName || '';
            }

            this.clearForm();

            Odigeo._.each(passenger, function(value, key) {
                if (!Odigeo._.contains(['documents', 'frequentFlyerCardCodes'], key)) {
                    fields[key] = value;
                }
            });

            Odigeo._.each(fields, Odigeo._.partial(this._fillField, this.$cachedSelectors.formContent, _, _, true), this);
            this._refreshInputs();

            if (!this.widget.options.isBuyer) {
                if (!Odigeo._.isEmpty(passenger.documents)) {
                    var acceptedDocuments = Odigeo._.map($documentSection.find('.document_select option').not('[placeholder]'), function(el) {
                        return $(el).val();
                    });
                    var document = Odigeo._.find(passenger.documents, function(doc) {
                        return acceptedDocuments.indexOf(doc.identificationType) > -1;
                    });

                    this._fillPassengerDocument($documentSection, document);
                }
            }
            // Fill prices
            Odigeo._.each(
                this.$el.find('.js_baggageType[data-fieldtype="baggageType"]'),
                function(el) {
                    var $el = $(el);
                    var dataIndex = $el.attr('data-index');
                    var numBags;
                    var price;
                    var segmentIndex;
                    var kilos = $el.attr('data-kilos');

                    if (!Odigeo._.isEmpty(passenger.baggageSelectionDTOs) && !Odigeo._.isUndefined(passenger.baggageSelectionDTOs) && dataIndex > 0) {
                        var selectedDescriptor = Odigeo._.find(passenger.baggageSelectionDTOs[dataIndex - 1], {
                            baggageDescriptor: {baggageType: 'BAGGAGE'},
                        });
                        $el.val(selectedDescriptor.price);
                        numBags = selectedDescriptor.baggageDescriptor.pieces;
                        price = selectedDescriptor.price;
                        segmentIndex = passenger.baggageSelectionDTOs[dataIndex - 1].segmentTypeIndexDTO;
                        this.widget.model.set({selectedBaggageQuantity: numBags});
                        Odigeo.trigger('passengers_manager' + ':baggageChange', {
                            type: 'baggage',
                            id: this.widget.id,
                            index: dataIndex,
                            data: {
                                price: parseFloat(price),
                                quantity: parseFloat(numBags),
                                segmentIndex: segmentIndex,
                                kilos: kilos,
                            },
                        });
                    }
                },
                this
            );
        },

        _correctBirthdayInput: function(passengerType) {
            var $calendar = this.$cachedSelectors.allCalendars.filter('[data-name="dateOfBirth"]');
            $calendar.data('validationType', Odigeo._.invert(this.widget.passengerTypes)[passengerType] + '_DATE_OF_BIRTH');
            if (!Odigeo._.isEmpty($calendar.val())) {
                this._validateField({field: $calendar});
            }
        },

        _fillPassengerDocument: function($documentSection, passengerDocument) {
            Odigeo._.each(
                $documentSection.find('[data-name]'),
                function(el) {
                    var $el = $(el);

                    $el.val(passengerDocument[$el.data('name')]);
                    this._refreshInputs($el);
                },
                this
            );
        },

        _fillField: function($form, value, key, autoFilled) {
            var $el = $form.find('[data-name="' + key + '"]:not([type="hidden"])');

            if ($el.length) {
                $el.val(value);
                this._validateField({field: $el, autoFilled: autoFilled});

                switch (key) {
                    case 'dateOfBirth':
                        Odigeo.AB.isCobaltDesktopForms
                            ? Odigeo.UIElements.enhanceDateWithSelects.setCobaltDate($el, value)
                            : Odigeo.UIElements.enhanceDateWithSelects.setDate($el, value);
                        break;
                    case 'name':
                        $el.trigger(Odigeo.Events.blur, {notValidate: false});
                        break;
                }
            }
        },

        _refreshInputs: function($inputs) {
            var calendars = $inputs ? $inputs.filter('.calendar_input') : this.$cachedSelectors.allCalendars.filter('.submit_field_focusable');
            var selects = $inputs ? $inputs.filter('select') : this.$cachedSelectors.selectsPlaceholder;

            Odigeo._.each(
                calendars,
                function(el) {
                    this._toggleCalendar($(el), !!$(el).val());
                },
                this
            );

            Odigeo._.each(
                selects,
                function(el) {
                    this._toggleSelect($(el));
                },
                this
            );
        },

        _handleChangeText: function(evt) {
            this._validateField({field: $(evt.target), silentOnSuccess: true});
        },

        _toggleCalendar: function($calendar, enable) {
            $calendar.siblings('.calendar_placeholder').toggleClass('hidden', enable);
            $calendar.toggleClass('hidden', !enable);
        },

        _toggleSelect: function($select) {
            $select.toggleClass('placeholder', !$select.val());
        },

        _focusHandler: function(evt) {
            var $fieldWrapper = $(evt.target).closest('.validation_field');
            $fieldWrapper
                .next('.form_disclaimer')
                .not('.disabled')
                .addClass('showed');
            $fieldWrapper.addClass('focused');
        },

        _populateName: function() {
            const traveller = Odigeo._.find(this.model.user.traveller, {id: Number(this.model.passengerSelectedId)}).profile;
            this.$cachedSelectors.name.val(traveller.name);
            this.$cachedSelectors.firstLastName.val([traveller.firstLastName, traveller.secondLastName].join(' ').trim());
            this.$cachedSelectors.passangermanagerSecondLastName.val('');
            this._validateField({field: $(this.$cachedSelectors.name), silent: false, fullvalidation: true});
            this._validateField({field: $(this.$cachedSelectors.firstLastName), silent: false, fullvalidation: true});
        },

        checkMatchingNames: function() {
            const isNifValidation = this.$cachedSelectors.identificationType.val() === 'NIF';
            let isFullNameResidentValid = true;
            let fullNameInputs = [];
            Odigeo._.forEach(isNifValidation ? this.$cachedSelectors.fullResidentName : this.$cachedSelectors.fullName, function(inputField) {
                isFullNameResidentValid = isFullNameResidentValid && !Odigeo._.isEmpty($(inputField).val());
                fullNameInputs.push($(inputField).val());
            });

            if (isFullNameResidentValid) {
                const travellerProfile = Odigeo._.find(this.model.user.traveller, {id: Number(this.model.passengerSelectedId)}).profile;
                const fullPrimeName = [travellerProfile.name, travellerProfile.firstLastName, travellerProfile.secondLastName].join(' ').trim();
                fullNameInputs = fullNameInputs.join(' ');
                if (fullNameInputs.toUpperCase() !== fullPrimeName.toUpperCase()) {
                    $(this.$cachedSelectors.residentLastNames).val('');
                    this._validateField({field: $(this.$cachedSelectors.firstLastName), silent: false, fullvalidation: true});
                    this._validateField({field: $(this.$cachedSelectors.passangermanagerSecondLastName), silent: false, fullvalidation: true});
                    Odigeo.trigger(`${this.widget.name}:residentDoesntMatchNames`, {name: travellerProfile.name, fullName: fullPrimeName});
                }
            }
        },

        _togglePasswordVisibility: function() {
            var iconClass = this.$cachedSelectors.passwordIcon.hasClass('odf-icon-eye-off') ? 'odf-icon-eye-open' : 'odf-icon-eye-off';
            this.$cachedSelectors.passwordIcon.removeClass('odf-icon-eye-open odf-icon-eye-off').addClass(iconClass);
            this.$cachedSelectors.passwordInput.attr('type', this.$cachedSelectors.passwordInput.attr('type') === 'password' ? 'text' : 'password');
        },

        storePriceFreezeData: function($el) {
            const fieldName = $el.data('name');
            const priceFreezeDataName = priceFreezeDataNames[fieldName];
            if (priceFreezeDataName) {
                const priceFreezeSession = Odigeo.Utils.parseJson(Odigeo.Session.get('pf:session')) || {};
                const newBuyerData = Object.assign({}, priceFreezeSession.buyer, {[priceFreezeDataName]: $el.val()});
                const newPFSession = Object.assign({}, priceFreezeSession, {buyer: newBuyerData});
                Odigeo.Session.set('pf:session', JSON.stringify(newPFSession));
            }
        },

        onBlurValidateElement: Odigeo._.debounce(function($el) {
            if (this._validateField({field: $el})) {
                this.storeLocalData(false);
                if (Odigeo.AB.isPaymentRetryInsufficientFunds && (this.widget.id === 'passengers0' || this.widget.id === 'buyer')) {
                    this.storePriceFreezeData($el);
                }
            }
        }, 100),

        _inputBlurHandler: function(evt, params) {
            var $el = $(evt.target);
            var $fieldWrapper = $el.closest('.validation_field');

            $el.val(Odigeo.Utils.trim($el.val()));

            if (!!params && !params.notValidate) {
                return;
            }

            if ($el.attr('autocapitalize') === 'on') {
                $el.val(Odigeo.Utils.capitalize($el.val()));
            }

            if ($el.attr('required') === 'required' || ($el.hasClass('optional') && $el.val()) || this.widget.options.fillDataWithSession) {
                // Notify handler that now it's dirty or used (arguments can be added in the future)
                Odigeo.trigger(this.widget.id + ':dirty');
                this.onBlurValidateElement($el);
            }

            $fieldWrapper.removeClass('focused');

            $fieldWrapper
                .next('.form_disclaimer')
                .not('.disabled')
                .removeClass('showed');

            if ($el.data('name') === 'password' && Odigeo._.isEmpty($el.val())) {
                this.$cachedSelectors.passwordBox.removeClass('valid');
            }
            $el.toggleClass('placeholder', Odigeo._.isEmpty($el.val()));
            if (
                this.model.passengerSelectedId === 0 &&
                this.isResident() &&
                ['name', 'firstLastName', 'secondLastName'].indexOf($el.data('name')) > -1
            ) {
                this.checkMatchingNames();
            }
        },

        _dataChangedHandler: function() {
            Odigeo.trigger(this.widget.id + ':dirty');
            this._validateAllFields(true);
        },

        getWrongChars: function($field, label) {
            var wrongCharacters = this.fieldUtils.giveWrongCharacters($field);
            return wrongCharacters && !this.isEmail($field.data('name')) ? label + '_char:' + wrongCharacters : label;
        },

        getCorrectSibling: function($param) {
            var $parent = $param.parent();
            return $parent.siblings('input').val() ? $parent.siblings('input') : $parent.parent().siblings('input');
        },

        _validateField: function(params) {
            var $fieldParam = $(params.field);
            var $field = Odigeo._.isEmpty($fieldParam.data('name')) ? this.getCorrectSibling($fieldParam) : $fieldParam;
            var silent = params.silent || false;
            var fullValidation = params.fullvalidation || false;
            const checkValidity = params.checkValidity || false;
            var silentOnSuccess = params.silentOnSuccess || false;
            var autoFilled = params.autoFilled || false;
            var validity = this.widget.model.checkValidity($field, autoFilled);
            var empty = Odigeo._.isUndefined(validity);
            var isOptional = $field.hasClass('optional') || $field.data('requiredoptional') === 'optional';
            var eventType;
            var dateTypes = ['EXPIRATION_DATE', 'ADULT_DATE_OF_BIRTH', 'INFANT_DATE_OF_BIRTH', 'CHILD_DATE_OF_BIRTH'];
            const isValid = (isOptional && empty) || (!empty && validity);

            if (Odigeo._.isEmpty($field.data('name'))) {
                return;
            }

            if (!fullValidation && Odigeo._.isEmpty($field.val()) && Odigeo._.includes(dateTypes, $field.data('validationType'))) {
                return;
            }

            if (!silent) {
                var $wrapper = $field.closest('.validation_field').removeClass('valid invalid empty');
                var $documentSection = $field.closest('.document_section').removeClass('success error');
                var passengerHeader = this.$cachedSelectors.passengerHeader.removeClass('success error').add($documentSection);
                var emailValue = this.widget.view.$cachedSelectors.buyerEmail.val();
                var fieldValue = $field.val();
                var isValidationMailError;
                if (emailValue && fieldValue) {
                    fieldValue = fieldValue.toLowerCase();
                    emailValue = emailValue.toLowerCase();
                }
                isValidationMailError = $field.data('name') === 'validationMail' && fieldValue !== emailValue && emailValue;
                var analyticsLabelSuffix;
                var label;
                var type;

                if (validity === false || (empty && !isOptional)) {
                    $wrapper.addClass(Odigeo._.isUndefined(validity) ? 'empty' : 'invalid');
                    this.fieldUtils.showError($wrapper, true);
                    passengerHeader.addClass('error');
                    analyticsLabelSuffix = Odigeo._.isUndefined(validity)
                        ? '_missing_error'
                        : isValidationMailError
                            ? '_does_not_match_error'
                            : '_invalid_error';

                    // Analytics: event tracking
                    eventType = this.widget.options.isBuyer ? 'buyer' : 'pax';
                    type = fullValidation ? '_submit' : '_inline';
                    label = eventType + '_' + $field.data('name').toLowerCase() + type + analyticsLabelSuffix;
                    if ($field.val() && fullValidation) {
                        label = this.getWrongChars($field, label);
                    }
                    trackingUtils.trackEvent(eventType + '_details_error', label);
                } else if (!Odigeo._.isUndefined(validity) && !silentOnSuccess) {
                    var $documentFields = $documentSection.find('.validation_field');

                    $wrapper.addClass('valid');
                    passengerHeader.addClass(this._validateAllFields(true) ? 'success' : '');
                    $documentSection.toggleClass('success', $documentFields.not('.valid').length === 0);
                    $documentSection.toggleClass('error', $documentFields.filter('.invalid').length > 0);
                }
            }

            return checkValidity ? isValid : silent || isValid;
        },

        isEmail: function(name) {
            return name === 'mail' || name === 'validationMail';
        },

        _validateAllFields: function(silent, $stopField, checkValidity) {
            var $allInputsVisibleRequired = this.$cachedSelectors.allInputs
                .filter(this.widget.options.validateOnlyRequired)
                .filter(':visible')
                .filter(':not([data-required=false])');
            var $allInputsOptionalNotEmpty = this.$cachedSelectors.allInputs.filter('.optional').filter(function() {
                return $(this).val();
            });
            var $inputsToValidate = $allInputsVisibleRequired
                .add($allInputsOptionalNotEmpty)
                .add(this.$cachedSelectors.visibleDateFields)
                .slice(0, $stopField ? this.$cachedSelectors.allInputs.index($stopField) : undefined);
            var allValid = Odigeo._.reduce(
                $inputsToValidate,
                function(acc, el) {
                    return this._validateField({field: $(el), silent: silent, fullvalidation: true, checkValidity}) && acc;
                },
                true,
                this
            );

            if (!$stopField) {
                Odigeo.trigger(this.widget.name + ':passengerValid', this.widget.id, allValid);
            }
            return allValid;
        },

        _validateUntilField: function(event) {
            if ($(event.target).attr('required') === 'required' || ($(event.target).hasClass('optional') && $(event.target).val() !== '')) {
                this._validateAllFields(false, $(event.target));
            }
        },

        _selectStoredPassenger: function(passengerId) {
            var passenger = this.widget.model.readPassenger(passengerId);

            this.widget.model.passengerID = passengerId;
            this.fillPassengerData(passenger);
            if (!this.widget.options.isBuyer) {
                this._validateAllFields();
            }
        },

        _storedPassengersChangeHandler: function(evt, silent) {
            var passengerId = evt.target.value;
            var analyticsPrefix = this.widget.options.isBuyer ? 'buyer' : 'pax';
            var analyticsPaxPosition = !this.widget.options.isBuyer ? this.widget.id[this.widget.id.length - 1] + '_' : '';

            if (passengerId) {
                this._selectStoredPassenger(passengerId);
            } else {
                this.widget.model.passengerID = null;
                this.clearForm();
            }

            // Analytics: event tracking
            // Check if event was human triggered
            if (!Odigeo._.isUndefined(evt.originalEvent)) {
                trackingUtils.trackEventWithCategory(
                    'flights_pax_page',
                    analyticsPrefix + '_details',
                    analyticsPrefix + '_selected_' + analyticsPaxPosition + evt.target.selectedIndex
                );
            }

            if (!silent) {
                Odigeo.trigger(this.widget.id + ':dirty');
            }

            Odigeo.trigger(this.widget.name + ':passengerPicked', {
                id: this.widget.id,
                data: passengerId,
            });
        },

        _passengerSelectorHandler: function(event) {
            this.widget.options.travellerType = this.widget.passengerTypes[$(event.currentTarget).val()];
            this._correctBirthdayInput(this.widget.options.travellerType);
        },

        selectPassenger: function(passengerId) {
            var $select = this.$cachedSelectors.storedPassengers;
            if ($select.children('[value="' + passengerId + '"]').length) {
                $select[0].value = passengerId;
                $select.trigger(Odigeo.Events.change, true);
            }
        },

        _setSelectedPassenger: function(passengerId, passengerType) {
            if (!Odigeo._.isEmpty(passengerId.toString())) {
                this.widget.options.travellerType = passengerType || this.widget.options.travellerType;
                this._correctBirthdayInput(this.widget.options.travellerType);
                this._selectStoredPassenger(passengerId);
            } else {
                this.widget.model.passengerID = null;
                this.clearForm(Odigeo._.isUndefined(passengerType) || Odigeo._.isEmpty(passengerType) ? true : undefined);
            }
        },

        _addDocumentSectionHandler: function() {
            var $tmpl = this.$cachedSelectors.documents.first().clone();
            var maxCount = $tmpl.find('.document_select > option').length - 1;
            var $documentsContainer = this.$cachedSelectors.documentsContainer;
            var documentsCount = $documentsContainer.find('.document_section').length;
            var $newDocumentSection;

            if (documentsCount >= maxCount) {
                return;
            }

            $newDocumentSection = $tmpl.insertBefore($documentsContainer.children().last()).removeClass('hidden');
            $newDocumentSection.find('.remove_code').on(Odigeo.Events.tap, Odigeo._.bind(this._removeDocumentSection, this));
            this.$cachedSelectors.addDocumentBtn.toggleClass('hidden', ++documentsCount >= maxCount);
            this._reCacheAndBindAllInputs();
            return $newDocumentSection;
        },

        _removeDocumentSection: function(event) {
            $(event.target)
                .parents('.document_section')
                .remove();
            this.$cachedSelectors.addDocumentBtn.removeClass('hidden');
            this._reCacheAndBindAllInputs();
            this._dataChangedHandler();
        },

        setTravellerById: function(travelerSelectedId, triggerChange) {
            this.$cachedSelectors.customerSelector.val(travelerSelectedId);
        },

        _initPassengerList: function() {
            // Check if a traveller is selected
            if (this.model.passengerSelectedId > -1) {
                this.membershipActions(this.model.passengerSelectedId);
                this.setTravellerById(this.model.passengerSelectedId);
            } else if (!this.isStepBack()) {
                this._emptyCollectionFields(this.$cachedSelectors.passengerInputs);
            }
            // Bind events
            this.$cachedSelectors.customerSelector.off().on(Odigeo.Events.change, Odigeo._.bind(this.onPassengerSelected, this));
            this.updatePassengerOptionSelected(false);
            this.sendNameToSidebar(this.model.passengerSelectedId);
        },

        isStepBack: function() {
            var lastRouteChange = Odigeo.Utils.parseJson(Odigeo.Session.get('lastRouteChange'));
            var pages = ['payment', 'insurance', 'flightinfo'];
            return !Odigeo._.isNull(lastRouteChange) && Odigeo._.includes(pages, lastRouteChange.from.name);
        },

        _selectedTravellerUpdateValues: function(id) {
            var traveller = Odigeo._.findWhere(this.model.user.traveller, {id: Number(id)});
            if (traveller) {
                this._fillValues(this.$cachedSelectors.passengerInputs, this.widget.passengerMap, traveller, 'name', true);
            } else {
                this._emptyCollectionFields(this.$cachedSelectors.passengerInputs);
            }
            return traveller;
        },

        isMember: function(traveller) {
            return traveller.id === 0;
        },

        hideNameAndSurname: function(hasToHide) {
            const fieldsToHide = {name: '', firstLastName: ''};
            Odigeo._.find(
                this.$cachedSelectors.passengerInputs,
                Odigeo._.bind(function(element) {
                    const $element = $(element);
                    if (!Odigeo._.isEmpty(Odigeo._.pick(fieldsToHide, $element.data('name')))) {
                        $element.closest(this.$cachedSelectors.passengerFields).toggleClass('odf-hidden', hasToHide);
                    }
                }, this)
            );
        },

        showMembershipIcon: function(hasToShow) {
            this.$cachedSelectors.membershipSignal.toggleClass('odf-hidden', !hasToShow);
            this.$cachedSelectors.membershipExtraInfo.toggleClass('odf-hidden', !hasToShow);
            this.$cachedSelectors.paxSelectorLabel.toggleClass('odf-hidden', hasToShow);
            this.$cachedSelectors.paxSeparatorTitle.toggleClass('odf-hidden', !hasToShow);
        },

        showMembershipMobileLabel: function(hasToShow) {
            this.$cachedSelectors.selectOptionMember.toggleClass('odf-hidden', !hasToShow);
        },

        isResident: function() {
            return this.$el.find('input[data-name="travellerResidency"]').val() === 'true';
        },

        userIsPlusOrEmployee: function() {
            return [MEMBERSHIP_ACCOUNT_TYPE.PLUS, MEMBERSHIP_ACCOUNT_TYPE.EMPLOYEE]
                .includes(this.model.user?.membershipInfoDTO.membershipDTO.membershipType);
        },

        membershipActions: function(id, isPrimeTravellerUnselected) {
            if (this.widget.id === 'passengers0') {
                dispatch({type: SET_TRAVELLER_ID, entry: id});
            }
            const isMemberSelected = id === 0 || Odigeo.Membership.isMembershipSharingDiscount;
            const isMembershipSelection = isMemberSelected || this.model.passengerSelectedId === 0;
            const isEmpty = Odigeo._.isEmpty(this.model.user.membershipInfoDTO.membershipDTO);
            const isFreeAccount = isEmpty || (!isEmpty && !isMembershipStatusActivated(this.model.user.membershipInfoDTO.membershipDTO));
            const isNotResident = !this.isResident();
            const isTravelerDefined = isMemberSelected && id !== -1;
            if (isNotResident) {
                this.hideNameAndSurname(isTravelerDefined);
            }
            this.showMembershipIcon(isMemberSelected);
            this.showMembershipMobileLabel(isMemberSelected);
            if (isMembershipSelection) {
                Odigeo.trigger('membership:updatePremiumDisclaimers',
                    isMemberSelected || this.userIsPlusOrEmployee(),
                    isFreeAccount,
                    isPrimeTravellerUnselected);
            }
        },

        updatePassengerOptionSelected: function(trackEvent) {
            var passengerNumber = this.$cachedSelectors.customerSelector[0].selectedIndex;
            var fullNameInputs = [];
            var passengerOptionFound;

            if (this.model.passengerSelectedId === -1) {
                if (!this.isStepBack()) {
                    this._emptyCollectionFields(this.$cachedSelectors.passengerInputs);
                } else {
                    Odigeo._.forEach(
                        this.$cachedSelectors.passengerInputs.filter('[data-name="name"],[data-name="firstLastName"]'),
                        function(inputField) {
                            fullNameInputs.push($(inputField).val());
                        }
                    );
                    passengerOptionFound = Odigeo._.find(this.$cachedSelectors.customerSelector.find('option'), function(option) {
                        return Odigeo._.every(fullNameInputs, function(inputValue) {
                            return (
                                $(option)
                                    .html()
                                    .indexOf(inputValue) !== -1
                            );
                        });
                    });
                    if (!Odigeo._.isUndefined(passengerOptionFound)) {
                        this.model.passengerSelectedId = Number($(passengerOptionFound).val());
                        this.$cachedSelectors.customerSelector.val(this.model.passengerSelectedId);
                    }
                }
            } else {
                this._selectedTravellerUpdateValues(this.model.passengerSelectedId);
            }

            if (trackEvent) {
                this.trackingUtils.trackEvent(
                    'flights_pax_page',
                    this.model.passengerSelectedId === -1 ? 'select_new_pax' : 'select_stored_pax_' + passengerNumber
                );
            }
        },

        onPassengerSelectedAction: function(id, passengerNumber, isPrimeTravellerUnselected) {
            if (id > -1 && this._selectedTravellerUpdateValues(id)) {
                this.trackingUtils.trackEvent('pax_details', 'select_stored_pax_' + passengerNumber);
                Odigeo.trigger(this.widget.name + ':travellerSelected', {id: id});
            } else {
                this.trackingUtils.trackEvent('pax_details', 'select_new_pax');
                this._emptyCollectionFields(this.$cachedSelectors.passengerInputs);
            }
            this.membershipActions(id, isPrimeTravellerUnselected);

            if (this.model.passengerSelectedId > -1) {
                Odigeo.trigger(this.widget.name + ':travellerNotSelected', {id: this.model.passengerSelectedId});
            }
            if (this.model.passengerSelectedId === 0) {
                trackingUtils.trackEvent('unlocked', 'nag_remove_subscriber_confirm');
            }
            this.model.passengerSelectedId = id;
            this.sendNameToSidebar(id);
        },

        sendNameToSidebar: function(id) {
            var traveller = Odigeo._.findWhere(this.model.user.traveller, {id: Number(id)});
            var name = !Odigeo._.isUndefined(traveller) ? traveller.profile.name : '';

            Odigeo.trigger(this.widget.name + ':sendNameToSidebar', {
                name: name,
                index: this.widget.options.index,
                id: id,
            });
        },

        onPassengerSelectedCancel: function(isCancelButton) {
            var eventLabel = isCancelButton === true ? 'nag_remove_subscriber_cancel' : 'nag_remove_subscriber_close';
            trackingUtils.trackEvent('unlocked', eventLabel);
            this.$cachedSelectors.customerSelector.val(this.model.passengerSelectedId);
        },

        onPassengerSelected: function() {
            const id = Number(this.$cachedSelectors.customerSelector.val());
            const passengerNumber = this.$cachedSelectors.customerSelector[0].selectedIndex;
            if (this.model.passengerSelectedId === 0) {
                trackingUtils.trackEvent('unlocked', 'nag_remove_subscriber_displayed', null, true);
                if (!Odigeo.Membership.isMembershipSharingDiscount &&
                     !this.userIsPlusOrEmployee()) {
                    Odigeo.UIElements.showLightboxWarning(
                        'od-passenger-lightbox-edit',
                        Odigeo._.bind(this.onPassengerSelectedAction, this, id, passengerNumber, true),
                        Odigeo._.bind(this.onPassengerSelectedCancel, this),
                        this.widget.options.lightboxTexts
                    );
                } else {
                    this.onPassengerSelectedAction(id, passengerNumber, false);
                }
            } else {
                this.onPassengerSelectedAction(id, passengerNumber, false);
            }
        },

        updatePassengerSelected: function() {
            Odigeo.trigger(this.widget.name + ':travellerSelected', {id: this.model.passengerSelectedId});
        },

        onHideTraveller: function(data) {
            if (
                Odigeo._.isObject(data) &&
                (data.id || data.id === 0) &&
                data.id !== -1 &&
                this.$cachedSelectors.customerSelector.val() !== data.id.toString()
            ) {
                this.$cachedSelectors.customerSelector
                    .find('option[value=' + data.id + ']')
                    .addClass('hidden')
                    .attr('disabled', true);
            }
        },

        onShowTraveller: function(data) {
            if (data.id !== -1) {
                this.$cachedSelectors.customerSelector
                    .find('option[value=' + data.id + ']')
                    .removeClass('hidden')
                    .removeAttr('disabled');
            }
        },

        hidePassengerList: function() {
            this.$cachedSelectors.customersPaxManager.addClass('hidden');
            this.hideNameAndSurname(false);
            this.showMembershipIcon(false);
            this.restoreFieldsLocalStorage();
        },

        _hasEmptyRequiredValues: function(obj, map) {
            var isEmptyValues = Odigeo._.isEmpty(obj);
            if (!isEmptyValues) {
                Odigeo._.each(map, function(property, value) {
                    if (Odigeo._.isEmpty(obj[value]) && property !== 'buyer' && property !== 'secondLastName') {
                        isEmptyValues = true;
                    }
                });
            }
            return isEmptyValues;
        },

        onUserNotLogged: function() {
            this.$cachedSelectors.hideOnUserLogged.removeClass('hidden');
            this.$cachedSelectors.fillBuyerCombo.removeClass('hidden');
            this.$cachedSelectors.customersPaxManager.addClass('hidden');
            this.$cachedSelectors.buyerNonEditableEmail.addClass('hidden');
            this.$cachedSelectors.buyerEditableEmail.removeClass('hidden');
            this.$cachedSelectors.buyerEditableValidationMail.removeClass('hidden');
            this.$cachedSelectors.travellerTitleWarning.removeClass('hidden');
            this.showNonEditableBuyerLayer(false);
            this.restoreFieldsLocalStorage();
        },

        hideNonEditableBuyerLayer: function(isTrackEvenent) {
            this.$cachedSelectors.fillBuyerCombo.addClass('hidden');
            this.showNonEditableBuyerLayer(false);
            if (isTrackEvenent) {
                this.trackingUtils.trackEvent('buyer_details', 'edit_buyer_details');
            }
        },

        showNonEditableBuyerLayer: function(isCollapsed) {
            if (isCollapsed) {
                this.$cachedSelectors.nonEditableBuyerLayer.removeClass('hidden');
            }
            this.$cachedSelectors.nonEditableBuyerLayer.trigger(isCollapsed ? 'expandPanel' : 'collapsePanel');
            Odigeo._.delay(
                Odigeo._.bind(function() {
                    this.$cachedSelectors.editableBuyerLayer.trigger(!isCollapsed ? 'expandPanel' : 'collapsePanel');
                }, this),
                400
            );
        },

        _existsField: function(elements, map, data, fieldName) {
            return !!Odigeo._.find(elements, function(elem) {
                var $element = $(elem);
                return map[$element.data(data)] === fieldName;
            });
        },

        fillDateOfBirth(obj, property, $element, isInputElement) {
            if (Odigeo.SessionScope.flow === 'desktop') {
                this._fillField(this.$cachedSelectors.formContent, Odigeo.Utils.formatDate(new Date(obj[property]), 'yyyy-mm-dd'), 'dateOfBirth');
            } else {
                $element[isInputElement ? 'val' : 'text'](Odigeo.Utils.formatDate(new Date(obj[property]), 'yyyy-mm-dd'));
            }
        },

        cleanBirthDate: function($element) {
            Odigeo.AB.isCobaltDesktopForms
                ? Odigeo.UIElements.enhanceDateWithSelects.setCobaltDate($element, '0-0-0')
                : Odigeo.UIElements.enhanceDateWithSelects.setDate($element, '0-0-0');
            $element.val(null);
        },
        checkMissingInfo: function(property, obj) {
            return (property === 'gender' && !obj.title) || (property && property !== 'gender' && !obj[property]);
        },
        _fillValues: function(elements, map, obj, data, isInputElement) {
            const existsMiddleName = this._existsField(elements, map, data, 'middleName');
            const existsSecondLastName = this._existsField(elements, map, data, 'secondLastName');
            const fixSecondSurname = this.widget.options.secondSurnameFix;
            const isMember = this.isMember(obj) && obj.profile;
            const isResident = this.isResident();
            obj = obj.profile || obj;
            let missing = false;
            Odigeo._.each(
                elements,
                Odigeo._.bind(function(element) {
                    var $element = $(element);
                    var property = map[$element.data(data)];
                    if (this.checkMissingInfo(property, obj)) {
                        missing = true;
                    }
                    if (property === 'gender') {
                        obj[property] = obj.title === 'MR' ? 'MALE' : 'FEMALE';
                        this.$el.find('input[data-name="travellerGender"][value="' + obj[property] + '"]').prop('checked', true);
                    } else if (property && obj[property]) {
                        if (fixSecondSurname && property === 'name' && !!obj.middleName && !existsMiddleName) {
                            $element.val(obj.name + ' ' + obj.middleName);
                            this.saveName = false;
                        } else if (property === 'firstLastName' && isMember && isResident) {
                            $element.val('');
                        } else if (fixSecondSurname && property === 'firstLastName' && !!obj.secondLastName && !existsSecondLastName) {
                            $element.val(obj.firstLastName + ' ' + obj.secondLastName);
                            this.saveName = false;
                        } else if (property === 'birthDate') {
                            this.fillDateOfBirth(obj, property, $element, isInputElement);
                        } else {
                            $element[isInputElement ? 'val' : 'text'](obj[property]);
                        }
                        if (isInputElement && property !== 'firstLastName') {
                            $element
                                .closest('.validation_field')
                                .removeClass('empty')
                                .addClass('valid');
                        } else if (property === 'firstLastName' && (!isMember || !isResident)) {
                            $element
                                .closest('.validation_field')
                                .removeClass('empty')
                                .addClass('valid');
                        } else {
                            $element
                                .closest('.validation_field')
                                .removeClass('valid')
                                .removeClass('empty');
                        }
                    } else if (property && !obj[property] && property === 'secondLastName') {
                        $element.val('');
                        if (isInputElement) {
                            $element
                                .closest('.validation_field')
                                .removeClass('valid')
                                .removeClass('empty');
                        }
                    } else if (property && !obj[property] && property === 'birthDate') {
                        this.cleanBirthDate($element);
                    }
                }, this)
            );
            return missing;
        },

        _prefillEmail: function(email) {
            if (email) {
                // Hide the email input because we use the user one
                this.$cachedSelectors.buyerNonEditableEmail.removeClass('hidden');
                this.$cachedSelectors.buyerEditableEmail.addClass('hidden');
                this.$cachedSelectors.buyerEditableValidationMail.addClass('hidden');
                // Prefill the values
                Odigeo._.each(this.$cachedSelectors.passengerEmail, function(emailField) {
                    $(emailField).text(email);
                });
                this.$cachedSelectors.editableBuyerLayer.find('[data-name="mail"], [data-name="validationMail"]').val(email);
            }
        },

        _prefillTravellerData: function(passenger) {
            var selectdPhonePrefix;
            var buyerMap;
            if (passenger && passenger.profile) {
                buyerMap = Odigeo._.invert(this.widget.contactDetailsMap.buyer);
                // Prefill editable layer
                this._fillValues(this.$cachedSelectors.passengerInputs, buyerMap, passenger.profile, 'name', true);
                // Prefill non editable layer
                this._fillValues(this.$cachedSelectors.nonEditableLayerFields, buyerMap, passenger.profile, 'noneditableLayer', false);
                // Prefill last name with firstlastname and secondlastname
                this.$cachedSelectors.editableBuyerLayer
                    .find('[data-name=lastName]')
                    .val(passenger.profile.firstLastName + ' ' + (passenger.profile.secondLastName ? passenger.profile.secondLastName : ''))
                    .closest('.validation_field')
                    .addClass('valid');
                // Prefill the phone prefix with the selected value of the drop down
                selectdPhonePrefix = this.$cachedSelectors.editableBuyerLayer.find('[data-name=phoneCode1] option:selected').text();
                this.$cachedSelectors.nonEditableBuyerLayer
                    .find('[data-noneditable-layer=phoneCode1]')
                    .text(selectdPhonePrefix && selectdPhonePrefix.match(/\((.*?)\)/) ? selectdPhonePrefix.match(/\((.*?)\)/).shift() : '');
            }
        },

        _prefillContactDetails: function(passengerAddress) {
            if (passengerAddress) {
                // Prefill editable layer
                this._fillValues(this.$cachedSelectors.passengerInputs, this.widget.contactDetailsMap, passengerAddress, 'name', true);
                // Prefill non editable layer
                this._fillValues(
                    this.$cachedSelectors.nonEditableLayerFields,
                    this.widget.contactDetailsMap,
                    passengerAddress,
                    'noneditableLayer',
                    false
                );
                // Prefill the country with the selected text of the drop down
                this.$cachedSelectors.nonEditableBuyerLayer
                    .find('[data-noneditable-layer=country]')
                    .text(this.$cachedSelectors.editableBuyerLayer.find('[data-name=country] option:selected').text());
            }
        },

        _updateContactDetailsData: function(traveller) {
            if (traveller && traveller.profile) {
                this._prefillTravellerData(traveller);
                this._prefillContactDetails(traveller.profile.address);
            }
        },

        onContactDetailsPassengerChanged: function() {
            var id = Number(this.$cachedSelectors.contactDetailsSelector.val());
            var traveller = Odigeo._.find(this.model.user.traveller, {id: Number(id)});
            this.model.passengerSelectedId = id;
            this._emptyCollectionFields(this.$cachedSelectors.passengerInputs);
            this.$cachedSelectors.hideOnUserLogged.toggleClass('hidden', id !== -1);
            this._updateContactDetailsData(traveller);
            this.showNonEditableBuyerLayer(false);
        },

        _hideOrShowNonEditableContactDetailsLayer: function(defaultPassenger) {
            var showEditableLayer =
                !Odigeo._.isUndefined(defaultPassenger) &&
                !this._hasEmptyRequiredValues(defaultPassenger.profile, this.widget.contactDetailsMap.buyer) &&
                !this._hasEmptyRequiredValues(defaultPassenger.profile.address, Odigeo._.invert(this.widget.contactDetailsMap)) &&
                this.model.user.email &&
                Odigeo._.size(this.widget.view.$cachedSelectors.identification) === 0 &&
                Odigeo._.size(this.widget.view.$cachedSelectors.stateName) === 0;

            this.showNonEditableBuyerLayer(showEditableLayer);
        },

        _emptyCollectionFields: function(collection) {
            var $input;
            Odigeo._.each(
                collection,
                Odigeo._.bind(function(input) {
                    $input = $(input);
                    if ($input.is('select')) {
                        $input.prop('selectedIndex', 0);
                    } else if ($input.data('role') === 'datePickerWith3Selects') {
                        this.cleanBirthDate($input);
                    } else if (
                        $input.prop('type') === 'date' ||
                        ($input.prop('type') === 'text' && $input.data('name') !== 'mail' && $input.data('name') !== 'validationMail')
                    ) {
                        $input.val('');
                    }
                    $input.parents('.validation_field').removeClass('valid invalid empty');
                }, this)
            );
        },

        checkBaggages: function() {
            this.$el.find('[data-fieldtype="baggageType"]').trigger('change');
        },

        restoreFieldsLocalStorage: function() {
            var selectCheckBoxes = {};
            const widgetId = this.widget.id === 'buyer-pay' ? 'buyer' : this.widget.id;
            if (widgetId !== 'buyer') {
                selectCheckBoxes.optionalRequest = this.$cachedSelectors.showOptionalRequests;
                selectCheckBoxes.showApisRequests = this.$cachedSelectors.showApisRequests;
                if (this.$cachedSelectors.ffyerButton.size() > 0) {
                    selectCheckBoxes.ffyerButton = this.$cachedSelectors.ffyerButton;
                }
            }

            if (widgetId === 'passengers0' && !this.model.travellerModel.importedFromLocal) {
                if (this.storeData.check('passengersData')) {
                    this.model.travellerModel.importedFromLocal = true;
                }
            }
            this.storeData.restore('passengersData', this.$cachedSelectors.passengerFullInputs, widgetId, selectCheckBoxes);
        },

        prefillCountryWithPrefixTelephone: function() {
            var passengersData = Odigeo.Utils.parseJson(Odigeo.Session.get('passengersData'));
            if (Odigeo._.isObject(passengersData) && Odigeo._.isObject(passengersData.buyer)) {
                this.$cachedSelectors.buyerCountry.val(passengersData.buyer.phoneCode1);
            }
        },

        storeLocalData: function(localStorage) {
            var otherValues = {};
            var fullInputs = this.$cachedSelectors.passengerFullInputs;
            const widgetId = this.widget.id === 'buyer-pay' ? 'buyer' : this.widget.id;

            if (widgetId !== 'buyer') {
                otherValues.optionalRequest = this.$cachedSelectors.showOptionalRequests.is(':checked');
                otherValues.showApisRequests = this.$cachedSelectors.showApisRequests.is(':checked');
                if (this.$cachedSelectors.ffyerButton.size() > 0) {
                    otherValues.ffyerButton = this.$cachedSelectors.ffyerButton.is(':checked');
                }
                if (!this.saveName) {
                    fullInputs = Odigeo._.reject(fullInputs, function(elem) {
                        return elem.name === 'name' || elem.name === 'firstLastName' || elem.name === 'middleName';
                    });
                }
            }

            this.storeData.save(localStorage, 'passengersData', fullInputs, widgetId, otherValues);
        },

        validFrequentCardNumberTracking() {
            Odigeo._.each(
                this.$cachedSelectors.passengerCardNumber,
                function(passengerCardNumber) {
                    var $passengerCardNumber = $(passengerCardNumber);
                    if (this.model.checkValidity($passengerCardNumber, true)) {
                        trackingUtils.trackEvent('frequent_flyer_widget', 'frequent_flyer_widget_number_correct');
                    }
                },
                this
            );
        },

        selectedMealTracking() {
            const $meal = this.$cachedSelectors.mealsSelector;
            if ($meal.size() > 0) {
                const mealValue =
                    $meal.prop('selectedIndex') > 0
                        ? $meal
                            .val()
                            .toLowerCase()
                            .replace('_', '')
                        : 'optional';
                trackingUtils.trackEvent('frequent_flyer_widget', 'frequent_flyer_widget_type_meal_' + mealValue);
            }
        },

        frequentFlyerCodesTrackingData: function(data) {
            var totalCardsFilled = 0;

            if (
                this.$cachedSelectors.showOptionalRequests.is(':checked') &&
                (this.$cachedSelectors.ffyerButton.is(':checked') || this.$cachedSelectors.ffyerButton.size() === 0)
            ) {
                totalCardsFilled = Odigeo._.reduce(
                    this.$cachedSelectors.passengerCardNumber,
                    function(total, passengerCardNumber) {
                        return $(passengerCardNumber).val() ? total + 1 : total;
                    },
                    0
                );
            }
            data.totalFilled = data.totalFilled + totalCardsFilled;
            data.totalCardsFields = data.totalCardsFields + this.$cachedSelectors.passengerCardNumber.size();
        },

        frequentFlyerCodesTrackingDataOnInit: function(data) {
            data.isMealDisplayed = data.isMealDisplayed || this.$cachedSelectors.mealsSelector.size() > 0;
            data.isFFDisplayed = data.isFFDisplayed || this.$cachedSelectors.moreOptionsBlock.size() > 0;
        },

        frequentFlyerMealsTracking: function(data) {
            var $meal = this.$cachedSelectors.mealsSelector;
            var mealValue;
            if ($meal.size() > 0) {
                mealValue = $meal.size() > 0 && $meal.prop('selectedIndex') > 0 ? '_' + $meal.val() : '_none';
                data.meals += mealValue;
                data.frequentFlyer += mealValue;
            }
        },

        updateAutocompleteGooglePlacesInput: function(evt) {
            if (this.widget.options.getAutocompleteWithoutLocation === 1) {
                return false;
            }

            const DELETE_KEY = 'Backspace';
            const ESCAPE_KEY = 'Escape';
            let place = (evt.target.value && evt.target.value.toString()) || null;
            let minimumPlaceLength = 3;
            if (this.widget.options.getAutocompleteWithoutLocation === 3) {
                minimumPlaceLength = 6;
            }

            if (evt.key !== DELETE_KEY && place && place.length >= minimumPlaceLength) {
                this.model.getGeolocationBySessionIp(place);
            } else if ((place && place.length <= minimumPlaceLength && document.querySelector('.places_suggestion')) || evt.key === ESCAPE_KEY) {
                this.googlePlacesHelper.removeListContainer();
            }
        },

        googlePlacesRequestErrorHandler: function(err) {
            return err;
        },

        getPlaceId: function(evt) {
            const elm = evt.target;
            const placeId = elm.getAttribute('data-place-id') || elm.parentNode.getAttribute('data-place-id');

            if (placeId) {
                const url = Odigeo.Settings.property('appContext') + '/service/googleplaces/getplacebyid';
                const success = this.googlePlacesHelper.populateForm;
                const error = Odigeo._.bind(this.googlePlacesRequestErrorHandler, this);
                const data = JSON.stringify({placeId});

                this.model.getGooglePlacesRest({
                    data,
                    dataType: 'json',
                    contentType: 'application/json',
                    type: 'POST',
                    url,
                    success,
                    error,
                });
            }
        },
        closeGooglePlaceAutocomplete: function() {
            if (document.querySelector('.places_suggestion')) {
                this.googlePlacesHelper.removeListContainer();
            }
        },
        onChangePaxAction: function(e) {
            Odigeo.trigger(this.widget.name + ':removePax', e);
        },
        trackingStoreDetails: function(e) {
            const $customersInfoSave = $('#customersinfosave');
            const saveData = $customersInfoSave.is(':checked');
            const trackingLabelStoreDetails = saveData ? 'check' : 'uncheck';
            trackingUtils.trackEvent('securely_store_details', 'securely-store-details_click:' + trackingLabelStoreDetails);
        },
    });
})();
